// extracted by mini-css-extract-plugin
export default {"Flash":"EditingForkBanner-module__Flash--BmTUB"};